import { useEffect, useState } from 'react';
import { ImSpinner8 } from 'react-icons/im';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getProfile } from '../redux/features/profile/profileSlice';
import RdfProfile from './Rdf';
import DefaultProfile from './Default';
import AfrProfile from './Afr';
import UnRwanda from './UnRwanda';
import WorldBank from './WorldBank';
import UndpRwanda from './UndpRwanda';
import CIICHIN from './CIICHIN';
import BKArenaProfile from './BKArenaProfile';
import QaSolutionsProfile from './QaSolutionsProfile';
import RsdaProfile from './RsdaProfile';
import MTNGROUP from './MtnGroup';
import Cop from './Cop';
import IUCN from './IUCN';
import Arthur from './Arthur';
import MadamArthur from './madamArthur';
import YouthConnect from './YouthConnect';
import { cleanAndCompareNames } from '../utils';
import MtnRwanda from './MtnRwanda';
import Momo from './Momo';
import UNHCR from './UNHCR';
import RwandaDay from './RwandaDay';
import AfricaNewsAgency from './AfricaNewsAgency';
import SFCapital from './SFCapital';
import RpfProfile from './RpfProfile';
import Bpr from './Bpr';
import Arieli from './Arieli';
import Rdb from './RDB';
import Mua from './Mua';
import EmpoweringDreamsFoundation from './EmpoweringDreamsFoundation';
import VisitRwanda from './VisitRwanda';
import AfricanMenCare from './AfricanMenCare';
import CNBProfile from './cnb';
import DefaultPremium from './defaultPremium';
import SmartAfrica from './SmartAfrica';
import ISCO from './ISCO';
import CrystalVenture from './CrystalVenture';
import Plan from './Plan';
import ConciergeAfrica from './ConciergeAfrica';
import PolandEmbassy from './PolandEmbassy';
import Guine from './Guine';
import RibProfile from './ribProfile';
import MoicProfile from './moicProfile';
import NatcomProfile from './natcomProfile';
import SierraLeoneProfile from './SierraLeone';
import ImBankProfile from './IMbank';
import UnCameroon from './UnCameroon';
import ImbankDefault from './ImbankDefault';
import Pinacles from './Pinacles';
import BrdProfile from './brdProfile';
import SenegalArmy from './SenegalArmy';
import UnEthiopia from './UnEthiopia';

const Profile = () => {
  // dispatch and params
  const dispatch = useDispatch();
  const { id } = useParams();

  // local states
  const [modal, setModal] = useState(false);
  // redux state
  const { profile, isLoading } = useSelector(state => state.profile);

  console.log('****', profile);

  // toggle modal function
  const toggle = () => setModal(prev => !prev);

  // handle order yours
  const handleOrderYours = () => {
    window.location.href = 'https://bizcotap.com/products';
  };

  // Assuming the tagName is stored in profile.data.tag_info.company
  const tagName = profile?.data?.tag_info?.fname || 'Default Tag'; // F
  // Update document title using useEffect
  useEffect(() => {
    document.title = `${tagName} - Bizcotap Tag`;
  }, [tagName]); // This will re-run the effect if tagName changes

  useEffect(() => {
    if (modal) {
      document.body.classList.add('block-scroll');
      setModal(true);
    } else {
      document.body.classList.remove('block-scroll');
      setModal(false);
    }
  }, [modal]);

  // useEffect
  useEffect(() => {
    const controller = new AbortController();
    dispatch(getProfile(id, { signal: controller.signal }));
    return () => controller.abort();
  }, [dispatch, id]);

  // isLoading
  if (isLoading) {
    return (
      <div className='flex justify-center pt-[46vh]'>
        <ImSpinner8 size={20} className='animate-spin text-primary' />
      </div>
    );
  }

  if (profile?.data?.tag_info?.company === 'Rwanda Defence Force') {
    return (
      <RdfProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'QA-solutions') {
    return (
      <QaSolutionsProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'RSDA') {
    return (
      <RsdaProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'BkArena') {
    return (
      <BKArenaProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tuid === '43504785864886365bb1f8') {
    return (
      <AfrProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if ( profile?.data?.tuid === '341285328634426aeb4019') {
    return (
      <UnRwanda
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '44862542565016ce398625') {
    return (
      <WorldBank
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (
    (profile?.data && cleanAndCompareNames(profile?.data?.tag_info?.company, 'UNDP Rwanda')) ||
    (profile?.data && cleanAndCompareNames(profile?.data?.tag_info?.company, 'UNDP South Africa')) ||
    (profile?.data && cleanAndCompareNames(profile?.data?.tag_info?.company, 'UNDP Central Africa'))
  ) {
    return (
      <UndpRwanda
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '414472205656da90840041') {
    return (
      <IUCN
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '2987544566517e00e1376f') {
    return (
      <CIICHIN
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'MTN Group') {
    return (
      <MTNGROUP
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'UNDP') {
    return (
      <UndpRwanda
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'un-cameroon') {
    return (
      <UnCameroon
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  
  else if (profile?.data?.tuid === '451816234632aa87c33363') {
    return (
      <MtnRwanda
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '8927638856325fd352e5dd' || profile?.data?.tuid === '6446888162cbf3cfd50e8') {
    return (
      <Momo
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '311358574656c9e388e0b3') {
    return (
      <Arthur
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '774039505656f05083e3e7') {
    return (
      <MadamArthur
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'cop') {
    return (
      <Cop
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'imbank-group') {
    return (
      <ImBankProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'imbank') {
    return (
      <ImbankDefault
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'RPF-INKOTANYI') {
    return (
      <RpfProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } 
  else if (profile?.data?.tag_info?.eventType === 'UNETH') {
    return (
      <UnEthiopia
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } 
  else if (profile?.data?.tag_info?.eventType === 'MUA-PREMIUM') {
    return (
      <Mua
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } 
  else if (profile?.data?.tag_info?.eventType === 'pinnacle') {
    return (
      <Pinacles
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'Ariel-Capital') {
    return (
      <Arieli
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'default-premium') {
    return (
      <DefaultPremium
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'RDB') {
    return (
      <Rdb
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'BPR') {
    return (
      <Bpr
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'rwandaday') {
    return (
      <RwandaDay
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'rib') {
    return (
      <RibProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'Sierra Leone') {
    return (
      <SierraLeoneProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } 
  else if (profile?.data?.tag_info?.eventType === 'natcom') {
    return (
      <NatcomProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } 
  else if (profile?.data?.tag_info?.eventType === 'moic') {
    return (
      <MoicProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'cnb') {
    return (
      <CNBProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Visit Rwanda') {
    return (
      <VisitRwanda
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'youthConnect') {
    return (
      <YouthConnect
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '5129767936596b1d9589fd') {
    return (
      <UNHCR
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '10308039565d78111eecdd' || profile?.data?.tuid === '6209835865d781ff1ae66') {
    return (
      <AfricaNewsAgency
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '94940889765e1b1f177887') {
    return (
      <SFCapital
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tuid === '7507616256491a075ada39') {
    return (
      <EmpoweringDreamsFoundation
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'African Men Care') {
    return (
      <AfricanMenCare
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Smart Africa') {
    return (
      <SmartAfrica
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'ISCO') {
    return (
      <ISCO
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'senegal-army') {
    return (
      <SenegalArmy
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
    else if (profile?.data?.tag_info?.eventType === 'BRD') {
    return (
      <BrdProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Crystal Venture') {
    return (
      <CrystalVenture
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Plan') {
    return (
      <Plan
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Concierge Africa') {
    return (
      <ConciergeAfrica
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else if (profile?.data?.tag_info?.eventType === 'Poland Embassy') {
    return (
      <PolandEmbassy
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
  else if (profile?.data?.tag_info?.eventType === 'Guine') {
    return (
      <Guine
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  } else {
    return (
      <DefaultProfile
        profile={profile}
        toggle={toggle}
        modal={modal}
        setModal={setModal}
        id={id}
        handleOrderYours={handleOrderYours}
        isLoading={isLoading}
      />
    );
  }
};
export default Profile;
